import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observe, toJS } from "mobx";
import { inject, observer } from "mobx-react";
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link, withRouter } from "react-router-dom";
import { Button, ButtonGroup, Col, Input, Row } from "reactstrap";
import { ITest } from "src/Interfaces/TestInterface";
import { IWell } from "src/Interfaces/WellInterface";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";

interface IReportState {
    testList: ITest[] | undefined;
    selectedTest: ITest | undefined;
    selectedTests: ITest[] | undefined;
    selectedWell: IWell | undefined;
    wellList: IWell[] | undefined;
    typeFilters: string[];
}

@inject('stores')
@observer
class ReportIndex extends React.Component{

    public props: any;
    private testStore: TestsStore;
    private wellStore: WellsStore;
    private userStore: UserStore;
    
    private wellListDisposer: any;
    private testListDisposer: any;
    public state: IReportState = {
        selectedTest: undefined,
        selectedTests: undefined,
        selectedWell: undefined,
        testList: undefined,
        typeFilters: [] as string[],
        wellList: undefined,
    };
    constructor(props: any) {
        super(props);
        this.testStore = props.stores.TestsStore;
        this.wellStore = props.stores.WellsStore;
        this.userStore = props.stores.UserStore;
    }

    public componentDidMount() {
        this.createDisposers();
        if (this.userStore.hasGenericPermission('Permissions.Reports.System.View')) {
            this.wellStore.getWellReportList();
        }
    }

    public createDisposers() {
        this.testListDisposer = observe(this.testStore, 'tests', (change: any) => {
            const testList = toJS(change.newValue);
            testList.sort((a: ITest, b: ITest) => Number(b.testDate) - Number(a.testDate));
            const selectedTest = testList[0] ? testList[0] : undefined;
            const selectedTests = testList[0] ? [testList[0]] : undefined;
            this.setState({
                selectedTest,
                selectedTests,
                testList
            });
        });

        this.wellListDisposer = observe(this.wellStore, 'wells', (change: any) => {
            const wellList: IWell[] = toJS(change.newValue);
            wellList.sort((a:IWell, b:IWell) => a.wellName.localeCompare(b.wellName));
            const wellId = this.props.match.params.wellId;
            let selectedWell;
            if (wellId) {
                selectedWell = wellList.find(w => w.id === wellId);                
            }
            
            if (!selectedWell) {
                selectedWell = wellList[0];
            }
            if (selectedWell) {
                this.testStore.getTestListForReport(selectedWell.id);
            }
            
            this.setState({
                selectedWell,
                wellList,
            });
        });
    }

    public disposeObservers = () => {
        this.testListDisposer();
        this.wellListDisposer();
    }

    public componentWillUnmount() {
        this.disposeObservers();
    }

    private convertStringArrayToString(StringArray: string[]){
        return StringArray.join();
    }

    public handleLinkClick = (blockLink:boolean) => (event:any) => {
        if(blockLink) {
            event.preventDefault();
        }
    }

    public handleTestSelect = (event:any) => {
        const testList = this.state.testList ? this.state.testList : [];
        const selectedTest = testList.find(test => test.id === event.target.value);
        this.setState({
            selectedTest
        });
    }

    public handleTestMultiSelect = (event: any) => {
        const selectedTests = [];
        const testList = this.state.testList ? this.state.testList : [];  
        for (const option of event.target.selectedOptions) {
            const selectedTest = testList.find(test => test.id === option.value);
            if(selectedTest) {
                selectedTests.push(selectedTest);
            }
        }
        this.setState({
            selectedTests
        });
    }

    public handleWellSelect = (event: any) => {
        const wellList = this.state.wellList ? this.state.wellList : [];
        const selectedWell = wellList.find(well => well.id === event.target.value);
        if (selectedWell) {
            this.testStore.getTestListForReport(selectedWell.id);
        }
        this.setState({
            selectedWell,
        });
    }

    public handleFilterBoxClick = (filterName: string) => (event: any) => {
        const filterIndex = this.state.typeFilters.findIndex((value: any) => value === filterName);
        let listFilters: any[] = this.state.typeFilters;
        if (filterName === 'all') {
            listFilters = [];
        } else if (filterIndex < 0) {
            listFilters.push(filterName);
        } else {
            listFilters.splice(filterIndex, 1);
        }
        if (listFilters.length === 4) {
            listFilters = [];
        }
        
        this.setState({typeFilters: listFilters}, () => {
            const wellList = this.state.wellList ? this.state.wellList : [];
            const selectedWell = wellList.filter(this.filterList)[0];
            if (selectedWell && selectedWell !== this.state.selectedWell) {
                this.testStore.getAllTestsDetailsReport(selectedWell.id);
            }
            this.setState({selectedWell});
        });
    }


    public buttonColor = (buttonName: string) => {
        const currList: any[] = this.state.typeFilters;
        if (currList.some(value => value === buttonName)) {
            return 'primary';
        }
        return 'outline-primary';
    }

    public allButtonTypeColor = () => {
        if (this.state.typeFilters.length > 0) {
            return 'outline-primary';
        }
        return 'primary';
    }

    public filterList = (item: IWell) => {
        let resultType;
        if (this.state.typeFilters.length === 0) {
            resultType = true;
        } else {

            for (const filterName of this.state.typeFilters)
            {
                if (item.wellStatus === filterName) {
                    resultType = true;
                }
            }
        }
        return resultType === true;
    }

    private showSystemReports = () => {
        return (
            this.state.testList
            && this.state.wellList
            && this.state.selectedWell
            && this.state.selectedWell.id
            && this.userStore.hasGenericPermission('Permissions.Reports.System.View')
            );
    }

    public getWellNameQuery = () => {
        if (this.state.selectedWell) {
            return '&well=' + encodeURIComponent(this.state.selectedWell.wellName);
        }
        return '';
    }
    public render() {
        const testList = this.state.testList;
        const wellList = this.state.wellList;
        const well = this.state.selectedWell ? this.state.selectedWell : new IWell();
        const selectedTests: any = this.state.selectedTests && this.state.selectedTests.length > 0 ? this.state.selectedTests: [new ITest()];
        const selectedTestsIDs = selectedTests.map((test: ITest) => test.id);
        const disableMudReportOption = !selectedTests || selectedTests[0].id === '' ? true : false; 
        const disableOption = disableMudReportOption || (selectedTests && selectedTests.length > 1) ? true : false; 
        const disableWellStory = selectedTests && selectedTests[0] && selectedTests[0].remarks && selectedTests[0].remarks.wellStories.length === 0;
        const disableWellClose = well.wellStatus === 'Active';
        if ((testList && wellList && well.id !== '' && this.userStore.hasGenericPermission('Permissions.Reports.System.View')) || this.userStore.hasGenericPermission('Permissions.Reports.Custom.View')){
            return (
                <div className="reportIndex">
                { this.showSystemReports() ?
                <Row>
                    <Col>
                        {selectedTests.length > 1 ?
                            <h2>Reports: {well.wellName} - {selectedTests.length} Well Tests Selected (Mud Reports Only)</h2>
                            :
                            <h2>Reports: {well.wellName} - {selectedTests[0].id !== "" ? moment.unix(selectedTests[0].testDate).tz(well.timeZoneName).format("MMM DD YYYY, h:mm a") : "Please Select a Test."}</h2>
                        }
                    </Col>
                </Row>
                :
                <Row>
                    <Col>
                            <h2>Reports:</h2>
                    </Col>
                </Row>
                }
                <Row>
                    <Col>
                        <Button type='button' color={this.allButtonTypeColor()} onClick={this.handleFilterBoxClick('all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('Active')} onClick={this.handleFilterBoxClick('Active')}>Active</Button>
                            <Button type='button' color={this.buttonColor('Finishing')} onClick={this.handleFilterBoxClick('Finishing')}>Finishing</Button>
                            <Button type='button' color={this.buttonColor('Closed')} onClick={this.handleFilterBoxClick('Closed')}>Closed</Button>
                            <Button type='button' color={this.buttonColor('Archived')} onClick={this.handleFilterBoxClick('Archived')}>Archived</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row>
                { this.showSystemReports() && wellList &&
                    <Col>
                        <h4>Wells</h4>
                        <Input
                            type="select"
                            size={15}
                            name="testList"
                            onChange={this.handleWellSelect}
                            value={well.id}
                            >
                            {wellList.filter(this.filterList).map((wellItem, index) => 
                                <option key={wellItem.id} value={wellItem.id}>{wellItem.wellName}</option>
                                
                                )}
                        </Input>
                    </Col>
                }
                { this.showSystemReports() && testList &&
                    <Col>
                        <h4>Tests</h4>
                        <Input
                            type="select"
                            multiple={true}
                            size={15}
                            name="testList"
                            onChange={this.handleTestMultiSelect}
                            value={selectedTestsIDs}
                            >
                            {testList.map((test, index) => 
                                <option key={test.id} value={test.id}>{moment.unix(test.testDate).tz(well.timeZoneName).format("MMM DD YYYY, h:mm a")}</option>
                                
                                )}
                        </Input>
                    </Col>
                }
                { this.showSystemReports() &&
                    <Col>
                        <h4>System Reports</h4>
                            <Link className={disableMudReportOption ? "DisableLink" : ""} onClick={this.handleLinkClick(disableMudReportOption)} target="_blank"
                                to={{
                                    pathname: `/print/well/${well.id}/test/multiple/mudreportpdf`,
                                    search: `${this.convertStringArrayToString(selectedTestsIDs)}`
                                }} 
                            >
                                <h6>Mud Report</h6>
                            </Link>
                            <Link className={disableOption ? "DisableLink" : ""} onClick={this.handleLinkClick(disableOption)} to={`/print/well/${well.id}/test/${selectedTests[0].id}/volumeaccountpdf`} target="_blank"><h6>Volume Accounting Report</h6></Link>                    
                            <Link className={disableOption ? "DisableLink" : ""} onClick={this.handleLinkClick(disableOption)} to={`/print/well/${well.id}/test/${selectedTests[0].id}/externalstoragepdf`} target="_blank"><h6>External Storage Report</h6></Link>

                            <Link className={disableMudReportOption ? "DisableLink" : ""} onClick={this.handleLinkClick(disableMudReportOption)} target="_blank" 
                                to={{
                                    pathname: `/print/well/${well.id}/test/multiple/volumeaccountsnapshotpdf`,
                                    search: `${this.convertStringArrayToString(selectedTestsIDs)}`
                                }}
                            >
                                <h6>Volume Accounting Snapshot</h6>
                            </Link>

                            <Link className={disableMudReportOption ? "DisableLink" : ""} onClick={this.handleLinkClick(disableMudReportOption)} target="_blank"
                                to={{
                                    pathname: `/print/well/${well.id}/test/multiple/productinventorysnapshotpdf`,
                                    search: `${this.convertStringArrayToString(selectedTestsIDs)}`
                                }}
                            >
                                <h6>Product Inventory Snapshot</h6>
                            </Link>
                            <Link className={disableOption || disableWellStory ? "DisableLink" : ""} onClick={this.handleLinkClick(disableOption || disableWellStory)} to={`/print/well/${well.id}/test/${selectedTests[0].id}/wellstorypdf`} target="_blank"><h6>Well Story</h6></Link>
                            <Link className={disableOption || disableWellClose ? "DisableLink" : ""} onClick={this.handleLinkClick(disableOption || disableWellClose)} to={`/print/well/${well.id}/wellclosereviewpdf`} target="_blank"><h6>Well Close Review Snapshot</h6></Link>
                    </Col>
                }
                { this.userStore.hasGenericPermission('Permissions.Reports.Custom.View') &&
                    <Col>
                        <h4>Tableau Reports</h4>
                        {/* REMOVED MUD-3762 <Link to={"/activereports?name=recap_mudmetrix" + this.getWellNameQuery()} target="_blank"><h6>Recap Report</h6></Link> */}
                        <Link to="/tableau/reports" target="_blank"><h6>Recap Report</h6></Link>
                        <Link to="/tableau/threeday" target="_blank"><h6>Snapshot Report</h6></Link>
                        <Link to="/tableau/recentrigactivity" target="_blank"><h6>Recent Rig Activity Report</h6></Link>

                        <Link to="/tableau/dispatchreport" target="_blank"><h6>Dispatch Report</h6></Link>
                        <Link to="/tableau/InventorySynopsis/InventorySynopsis" target="_blank"><h6>Inventory Synopsis Report</h6></Link>
                        <Link to="/tableau/ReturnedvsReceived/ReturnedvsReceivedSummary" target="_blank"><h6>Received vs. Returned Report</h6></Link>
                        
                        <Link to="/tableau/HandoverReport/HandoverReport" target="_blank"><h6>Hand Over Report</h6></Link>
                        <Link to="/tableau/MissingDispatchTicketFiles/MissingDispatchFiles" target="_blank"><h6>Missing Dispatch Ticket Files</h6></Link>
                        {/*
                        Removed MUD-3290
                        <Link to={"/activereports?name=recap_wellproductInventory" + this.getWellNameQuery() } target="_blank"><h6>Well Inventory Chemical Summary</h6></Link>
                        <Link to={"/activereports?name=recap_chemicalusage" + this.getWellNameQuery() } target="_blank"><h6>Inventory Interval</h6></Link>
                        <Link to={"/activereports?name=recap_MudProperties" + this.getWellNameQuery() } target="_blank"><h6>Recap Remarks Interval</h6></Link>
                        <Link to={"/activereports?name=recap_intervalremarks" + this.getWellNameQuery() } target="_blank"><h6>Test Results Interval</h6></Link>
                        <Link to={"/activereports?name=recap_IntervalSummary" + this.getWellNameQuery() } target="_blank"><h6>Interval Summary</h6></Link> 
                        */}
                    </Col>
                }
                </Row>
            </div>
            ); 
        } else {
            return <FontAwesomeIcon 
                        icon={faSpinner}
                        spin={true}
                        size={"8x"}
                        style={{position: 'fixed', left: '50%', top: '35%'}}
                    />;
        }
    }
}

export default withRouter(ReportIndex);


// WEBPACK FOOTER //
// ./src/Components/Reporting/ReportIndex.tsx